import {useEffect} from 'react';
const useInitialfocus = ref => {
  useEffect(() => {
    ref.current.focus();
  }, [ref]);
};
export default useInitialfocus;
